module.exports = __webpack_public_path__ + "static/media/collaboration-icon.a6b876f8.svg";